import { Capacitor } from "@capacitor/core";
import { type MissionsManager } from "@rescuetablet/missions-client";
import { missionsServer, platform, version } from "../config";
import { type Logger } from "../log";
import { log } from "./config";

export async function createMissionsManager(args: {
  baseUrl?: string;
  userAgent?: string;
  logger: Logger;
}): Promise<MissionsManager> {
  const impl = await (Capacitor.isNativePlatform()
    ? import("./connect-native")
    : import("@rescuetablet/missions-client/browser"));
  return impl.createMissionsManager(args);
}

export const managerPromise = createMissionsManager({
  baseUrl: missionsServer,
  userAgent: `rescuetablet/${platform}/${version}`,
  logger: log,
});
